function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "svg-1970211348-a",
  d: "M30 18.073C30 11.405 24.627 6 18 6S6 11.405 6 18.073C6 24.1 10.388 29.094 16.125 30v-8.437h-3.047v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H21.83c-1.491 0-1.956.93-1.956 1.886v2.264h3.328l-.532 3.49h-2.796V30C25.612 29.094 30 24.1 30 18.073"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd",
  transform: "translate(-6 -6)"
}, React.createElement("mask", {
  id: "svg-1970211348-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#svg-1970211348-a"
})), React.createElement("g", {
  mask: "url(#svg-1970211348-b)"
}, React.createElement("path", {
  d: "M6 6h24v24H6z"
})));

var SvgFacebook = function SvgFacebook(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgFacebook;